import {takeEvery} from 'redux-saga/effects'
import {
  CHANGE_ADMISSION_STATUS,
  CHANGE_ADMISSION_STATUS_BULK,
  GET_ADMISSION_ASSESSMENTS,
  GET_ADMISSION_REPORT_APPLICANTS,
  GET_ADMISSION_REPORT_FILTERS,
  GET_ADMISSION_REPORT_SUMMARY,
  PREVIEW_ADMISSION_LETTER,
  SAVE_ADMISSION_ASSESSMENTS,
} from 'setup/redux/Actions/School/AdmissionReport/ActionTypes/ApiActionTypes'

import fetchData from '../../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_ADMISSION_REPORT_FILTERS, fetchData)
  yield takeEvery(GET_ADMISSION_REPORT_SUMMARY, fetchData)
  yield takeEvery(GET_ADMISSION_REPORT_APPLICANTS, fetchData)
  yield takeEvery(CHANGE_ADMISSION_STATUS, fetchData)
  yield takeEvery(CHANGE_ADMISSION_STATUS_BULK, fetchData)
  yield takeEvery(PREVIEW_ADMISSION_LETTER, fetchData)
  yield takeEvery(GET_ADMISSION_ASSESSMENTS, fetchData)
  yield takeEvery(SAVE_ADMISSION_ASSESSMENTS, fetchData)
}

export default dataSaga
